<template>
  <div class="about" v-html="content"></div>
</template>

<script>
export default {
  data() {
    return {
      content:''
    }
  },
  methods:{
    async created() {
      let res = await this.$apis.loginServe.getPrivacy();
      this.content = res.content.detail[0].content;
    },
  },
  created() {
    document.title = '隐私政策'
    this.created()
  }
};
</script>

<style scoped lang="scss">
.about{
    width: 100%;
    padding: 20px;
    word-break:break-all;
    word-wrap:break-word;
}
</style>